module.exports = __webpack_public_path__ + "img/thumbnail_KirksDikDik_m_normal.aa12f72e.png";